import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {DiscountAuditReportModel} from "./discount-audit-report.model";

@Component({
    selector: "wbo-discount-audit-report",
    templateUrl: "./discount-audit-report.component.html",
    providers: [provideReportModel(DiscountAuditReportModel)]
})
export class DiscountAuditReportComponent extends AbstractReportPage {

    constructor(public model: DiscountAuditReportModel) {
        super();
    }
}
